import Button from "@mui/joy/Button";

export default function NoDataComponent() {
    return (
        <main className="flex flex-col items-center justify-center pt-24 ">
            <div className="flex flex-col items-center space-y-4">
                <h1 className="text-2xl font-semibold text-gray-700 dark:text-gray-300">No Data Available</h1>
                <p className="text-gray-500 dark:text-gray-400">We couldn't find any data. Please try again later.</p>
                <Button className="mt-4" variant="plain" onClick={() => window.location.reload()}>
                    Refresh
                </Button>
            </div>
        </main>
    )
}